import { s as stormLightTheme } from '../LocalModules/storm-ui-tokens/dist/esm/index-dYroKjHZ.js';

const defaultTheme = stormLightTheme;

export { defaultTheme as d };
//# sourceMappingURL=index-DJX_BCX_.js.map
